/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchUpdateTimecardEnforcementSettings} from '../api'

export const useMutationBatchUpdateTimecardEnforcementSettings = createReactQueryMutationHook('batchUpdateTimecardEnforcementSettings', batchUpdateTimecardEnforcementSettings)
